import styled from "@emotion/styled";

export const Section = styled.div`
  margin-bottom: 39px;
`;
